export default "__VITE_ASSET__C149OdtP__"